import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrashCan } from "@fortawesome/free-regular-svg-icons";
import { t } from "i18next";
import { ButtonSecondary } from "../atoms/ButtonSecondary";
import { MouseEventHandler } from "react";
import { Button } from "@/shared/components/atoms/Button";
import { faPencil, faTrash } from "@fortawesome/pro-regular-svg-icons";

export type ColumnActionsInventoryProps = {
  name: string;
  onEdit: MouseEventHandler;
  onDelete: MouseEventHandler;
  onViewTasks: MouseEventHandler;
  canEditInventory: boolean;
  canDeleteInventory: boolean;
};

const ColumnActionsInventory: React.FC<ColumnActionsInventoryProps> = ({
  name,
  onEdit,
  onDelete,
  onViewTasks,
  canEditInventory,
  canDeleteInventory,
}) => {
  return (
    <td className="relative whitespace-nowrap py-5 pl-3 pr-4 text-right text-sm font-medium sm:pr-0">
      <div className="flex gap-2 justify-end">
        {/* 
          <Button icon={faPencil} className="!text-blue-500" onClick={onDelete} />
          <Button icon={faTrash} className="!text-red-500" onClick={onDelete} />
        */}
        {canEditInventory && (
          <a
            onClick={onEdit}
            href="#"
            className="text-primary-600 hover:text-primary-900 mr-2 mt-3"
          >
            {t("general.edit")}
          </a>
        )}
        {canDeleteInventory && (
          <a
            onClick={onDelete}
            href="#"
            className="text-red-600 hover:text-red-900 mr-2 mt-3"
          >
            <FontAwesomeIcon icon={faTrashCan} />
          </a>
        )}
        <Button text={t("general.view_task")} onClick={onViewTasks} />
      </div>
    </td>
  );
};

export default ColumnActionsInventory;
